import { styled } from '@mui/material/styles';
import { Box, Card, TableContainer } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    width: '100%',
    margin: 0,
}));

export const StyledCard = styled(Card)(({ theme }) => ({
    marginTop: theme.spacing(3),
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    marginTop: theme.spacing(2),
    maxHeight: 600,
})) as typeof TableContainer;
